/** TanStack Query keys for issues and the site catalogs the issue form reads. */
export const issuesKeys = {
  // Shared with Monitor's issue reads, so one write refreshes every surface.
  list: (siteId: string | null) => ['monitor', 'issues', siteId] as const,
  users: (siteId: string | null) => ['site', 'users', siteId] as const,
  areas: (siteId: string | null) => ['site', 'areas', siteId] as const,
  professions: (siteId: string | null) => ['site', 'professions', siteId] as const,
  floorView: (siteId: string | null, floorId: string) => ['storage', 'floor-view', siteId, floorId] as const,
};
